import { useNavigate } from 'react-router-dom';

import { Loader } from '@thinknet-gmbh/platform-common-ui';

import { EditDatevForm } from 'src/pages/settings/components/datev/components/edit-datev-number/components/edit-datev-form';
import { useGetConsultantNumberById } from 'src/hooks/consultant-numbers/get-consultant-number-by-id.hook';
import { useUpdateConsultantNumber } from 'src/hooks/consultant-numbers/update-consultant-number.hook';
import { ROUTES } from 'src/components/app/app-routes.constants';
import { SETTINGS_PAGES } from 'src/pages/settings/settings.constants';

const EditConsultantNumber = ({ consultantNumberId }: { consultantNumberId: string }) => {
  const { datevNumber, loading } = useGetConsultantNumberById(consultantNumberId);
  const navigate = useNavigate();

  const { updateConsultantNumber } = useUpdateConsultantNumber({
    onSuccess: () => navigate(`${ROUTES.settings}?type=${SETTINGS_PAGES.datev}`),
  });

  const onFinishHandler = (values: any) => {
    const { datevNumber, details } = values;

    updateConsultantNumber({
      variables: {
        payload: {
          _id: consultantNumberId,
          consultantNumber: datevNumber,
          details,
        },
      },
    });
  };

  return loading ? (
    <Loader />
  ) : (
    <EditDatevForm data={datevNumber} onFinishHandler={onFinishHandler} isConsultantNumber />
  );
};

export default EditConsultantNumber;
